import { Label, LABEL_TYPE } from '@/components/generic';

type DetailsRowProps = {
  label: string;
  value: React.ReactNode;
  className?: string;
  labelWidth?: string;
  variant?: 'inline' | 'stacked';
};
// TODO: This component is used in multiple places, move it to common components after refactoring
export const DetailsRow = ({
  label,
  value,
  className,
  labelWidth = 'md:w-1/4',
  variant = 'inline'
}: DetailsRowProps) => {
  const isInline = variant === 'inline';
  return (
    <div
      className={`flex w-full ${
        isInline ? 'flex-col md:flex-row md:items-center' : 'flex-col'
      } ${className}`}>
      <Label
        text={`${label}:`}
        type={LABEL_TYPE.PARAGRAPH1}
        className={`text-secondary-gray ${isInline ? labelWidth : ''}`}
      />

      <div
        className={`text-primary-black ${
          isInline ? 'md:flex-1' : 'mt-1'
        } whitespace-pre-wrap break-words`}>
        {value}
      </div>
    </div>
  );
};
